import hasCount from './util/has-count'

export default {
    option: {
        value: 'event',
        label: 'Event',
        show: true,

        children: [
            {
                value: 'event-includes',
                label: 'Schedule includes',
                select: {
                    content: 'event'
                },
                match: hasCount({ type: 'event', all: false })
            },
            {
                value: 'not-event-includes',
                label: 'Not scheduled for event',
                select: {
                    content: 'event'
                },
                match: hasCount({ type: 'event', all: false, not: true })
            }
        ]
    }
}
